import { render, staticRenderFns } from "./GiubileoSchedaEditPage.vue?vue&type=template&id=494d401c"
import script from "./GiubileoSchedaEditPage.vue?vue&type=script&lang=js"
export * from "./GiubileoSchedaEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports